export const isEmpty = (inputValue) => !!!inputValue;



// WEBPACK FOOTER //
// ./src/helpers/paymentKiosk.js